import { useMemo as u } from "react";
import { useAuth as c } from "@dcentralexpedientedigital/fe-shared/hooks/use-auth";
import { Device as m } from "../utils/cms-types.js";
import { useMarketingAffiliateId as a } from "./use-marketing-cookies.js";
import { useMediaQuery as f } from "./use-media-query.js";
import { useUserCountry as p } from "./use-user-country.js";
import { useUserCountryState as d } from "./use-user-country-state.js";
import { useUserJurisdiction as g } from "./use-user-jurisdiction.js";
function l() {
  const t = c().auth.isAuthenticated, e = p(), o = d(), r = g(), i = u(() => (/* @__PURE__ */ new Date()).getTime(), []), s = f("lg"), n = a("affiliate_id");
  return u(() => ({
    isAuthenticated: t,
    countryCode: e,
    countryStateCode: o,
    jurisdiction: r,
    currentTime: i,
    device: s ? m.DESKTOP : m.MOBILE,
    marketingTags: n
  }), [
    t,
    e,
    o,
    r,
    i,
    s,
    n
  ]);
}
export {
  l as useDemographicsData
};
